import bannerImg from './banners/woman-helping-man-gym.jpg';

const reeducacaoAlimentar = (t) => ({
    id: 'reeducacao-alimentar',
    title: t('templates.items.reeducacaoAlimentar.title'),
    description: t('templates.items.reeducacaoAlimentar.description'),
    indicatedFor: t('templates.audiences.nutritionists'),
    stepsCount: 2,
    questionsSummary: [
        t('templates.items.reeducacaoAlimentar.summary.currentHabits'),
        t('templates.items.reeducacaoAlimentar.summary.favoriteFoods'),
        t('templates.items.reeducacaoAlimentar.summary.eatingTriggers'),
        t('templates.items.reeducacaoAlimentar.summary.longTermGoal'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.reeducacaoAlimentar.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.reeducacaoAlimentar.form.habits.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.reeducacaoAlimentar.form.habits.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'choices',
                        label: t('templates.items.reeducacaoAlimentar.form.habits.eatingOut.label'),
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: t('templates.items.reeducacaoAlimentar.form.habits.eatingOut.options.rarely') },
                                { id: 'opt-2', label: t('templates.items.reeducacaoAlimentar.form.habits.eatingOut.options.oneOrTwo') },
                                { id: 'opt-3', label: t('templates.items.reeducacaoAlimentar.form.habits.eatingOut.options.threeOrFour') },
                                { id: 'opt-4', label: t('templates.items.reeducacaoAlimentar.form.habits.eatingOut.options.everyDay') },
                            ],
                        },
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: t('templates.items.reeducacaoAlimentar.form.habits.favoriteFoods.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'text',
                        label: t('templates.items.reeducacaoAlimentar.form.habits.triggers.label'),
                        description: t('templates.items.reeducacaoAlimentar.form.habits.triggers.description'),
                        required: false,
                        settings: null,
                    },
                ],
            },
            {
                order: 2,
                title: t('templates.items.reeducacaoAlimentar.form.goals.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.reeducacaoAlimentar.form.goals.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'text',
                        label: t('templates.items.reeducacaoAlimentar.form.goals.sixMonthGoal.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'yes_no_maybe',
                        label: t('templates.items.reeducacaoAlimentar.form.goals.triedBefore.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default reeducacaoAlimentar;
